<template>
<ItpPage
  no-header
  contentClass="p-0"
  no-primary-button
  no-close-button
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Company"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <MaterialTabs
    :closeButton="modal"
    :tabManager="tabManager"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <ItpBox
      alignItems="center"
      class="mr-3"
      slot="tabs-start"
    >
      <b-breadcrumb
        class="m-0 bg-white"
      >
        <b-breadcrumb-item
          :text="messages.parent[effectiveRole]"
          :to="{ name: parentRouteName }"
        >
        </b-breadcrumb-item>
        <b-breadcrumb-item
          active
        >
          <strong>
            {{ item.snapshot('name') }}
          </strong>
        </b-breadcrumb-item>
      </b-breadcrumb>
      <ItpButton
        variant="light"
        icon="fa-sync-alt"
        :tooltip="'Reload'|gettext"
        :spinning="actions.reload.isRunning"
        size="sm"
        class="mr-2"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        :resource="item"
        no-text
        :dialogHeader="messages.delete[effectiveRole]"
        class="mr-2"
        @success="evh_6705964765214521_success($event, {})"
      >
      </BtnDeleteResource>
      <BtnSyncResource
        :resource="item"
        size="sm"
        class="ml-auto mr-2"
        v-if="loaded"
        @success="evh_6806515264385235_success($event, {})"
      >
      </BtnSyncResource>
    </ItpBox>
    <b-tab
      :title="'General'|gettext"
      class="container float-left"
    >
      <ItpRow>
        <ItpCol
          w="6"
        >
          <UcCompanyGeneral
            :item="item"
            :reload="lastLoaded"
            class="pb-4"
            @reload="evh_5477420070495986_reload($event, {})"
          >
          </UcCompanyGeneral>
          <UcContactList
            :parent="item"
            :reload="lastLoaded"
            class="pb-4"
            @reload="evh_6337614691287098_reload($event, {})"
          >
          </UcContactList>
          <UcEmployeeList
            :parent="item"
            :reload="lastLoaded"
            class="pb-4"
            @reload="evh_2406129194387753_reload($event, {})"
          >
          </UcEmployeeList>
          <UcCompanyFormContracts
            :company="item"
            :reload="lastLoaded"
            class="pb-4"
            @reload="evh_1840158740026147_reload($event, {})"
          >
          </UcCompanyFormContracts>
        </ItpCol>
        <ItpCol
          w="6"
        >
          <UcAddressList
            :parent="item"
            :reload="lastLoaded"
            class="pb-4"
            @reload="evh_4071170783051919_reload($event, {})"
          >
          </UcAddressList>
          <UcCompanyBankAccounts
            :parent="item"
            :reload="lastLoaded"
            class="pb-4"
            @reload="evh_7713630524832656_reload($event, {})"
          >
          </UcCompanyBankAccounts>
          <UcCommentsList
            :parent="item"
            :reload="lastLoaded"
            class="pb-4"
          >
          </UcCommentsList>
          <UcAttachmentsList
            :parent="item"
            :reload="lastLoaded"
            class="pb-4"
          >
          </UcAttachmentsList>
        </ItpCol>
      </ItpRow>
    </b-tab>
    <b-tab
      :title="'Billing list'|pgettext('Company')"
      class="container-fluid h-100"
    >
      <UcBillingList
        :companyId="isOwnCompany ? item.id : null"
        :clientId="isPartnerCompany ? item.id : null"
        :reload="lastLoaded"
        class="h-100"
        v-if="effectiveRole && tabManager.visited(1)"
      >
      </UcBillingList>
    </b-tab>
    <b-tab
      :title="'Invoices'|pgettext('Company')"
      class="container-fluid h-100"
    >
      <InvoiceLinesView
        :companyId="isOwnCompany ? item.id : null"
        :partnerId="isPartnerCompany ? item.id : null"
        :oid="item.id"
        :reload="lastLoaded"
        class="h-100"
        v-if="effectiveRole && tabManager.visited(2)"
      >
      </InvoiceLinesView>
    </b-tab>
    <b-tab
      :title="'Payments'|pgettext('Company')"
      class="container-fluid h-100"
    >
      <PaymentsView
        :parameters="{
    company: isOwnCompany ? item.id : null,
    partner: isPartnerCompany ? item.id : null
  }"
        :reload="lastLoaded"
        class="h-100"
        v-if="effectiveRole && tabManager.visited(3)"
      >
      </PaymentsView>
    </b-tab>
    <b-tab
      :title="'Statement'|pgettext('Company')"
      class="container-fluid h-100"
    >
      <UcCompanyStatement
        :oid="item.id"
        :reload="lastLoaded"
        class="h-100"
        v-if="effectiveRole && tabManager.visited(4)"
      >
      </UcCompanyStatement>
    </b-tab>
    <b-tab
      :title="'Accounts'|pgettext('Company')"
      class="container-fluid h-100"
      v-if="isOwnCompany"
    >
      <AccountsView
        :companyId="item.id"
        :reload="lastLoaded"
        class="h-100"
        v-if="tabManager.visited(5)"
      >
      </AccountsView>
    </b-tab>
  </MaterialTabs>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "company",
    path: "/companies/:id",
    component: "Company",
    params: [{
      name: "id",
      prop: "oid",
    }
      ,
    ]

  }
)

@Component()
export default class Company extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
  })
  role!: string;

  @Watch('role')
  onRole(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("role")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
    default: "full-screen",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  tabManager!: any;

  async $$load_tabManager() {
    return new this.$app.utils.LazyTabManager()
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('read_company', { parameters: { id: this.oid }, asResource: true })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['messages', 'tabManager', 'item', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          create: {
            own: this.$fn.pgettext("Company|Header", "New own company"),
            partner: this.$fn.pgettext("Company|Header", "New partner"),
          }
          ,
          parent: {
            own: this.$fn.pgettext("Company|Header", "Companies"),
            partner: this.$fn.pgettext("Company|Header", "Partners"),
          }
          ,
          delete: {
            own: this.$fn.pgettext("Company|Header", "Delete own company"),
            partner: this.$fn.pgettext("Company|Header", "Delete partner"),
          }
          ,
        }
        ,
        tabManager: null,
        item: null,
        ux: {
          initialLoadSpinner: true,
        }
        ,
        b_7315092382398562_modalBindings: {
          noHeader: true,
          contentClass: "p-0",
          noPrimaryButton: true,
          noCloseButton: true,
          size: "full-screen",
        }
        ,
      },
    }
  }

  get effectiveRole() {
    if (this.loaded) {

      return this.item ? (this.item.role || this.role) : this.role
    }
    return null;
  }

  get parentRouteName() {
    if (this.loaded) {

      return this.effectiveRole == 'own' ? 'app.ownCompanies' : 'app.partners'
    }
    return null;
  }

  get isOwnCompany() {
    if (this.loaded) {

      return this.effectiveRole === 'own'
    }
    return null;
  }

  get isPartnerCompany() {
    if (this.loaded) {

      return this.effectiveRole === 'partner'
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.oid == null && this.messages.create[this.role]
          ,
        this.item && this.item.snapshot('name')
          ,
        ]
        ,
        icon: this.$config.company.icons[this.role || this.item.role],
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2656_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2656, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_6705964765214521_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_success.executeFromDOM(this, event, scope);
  }

  async evh_6806515264385235_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6806515264385235_success.executeFromDOM(this, event, scope);
  }

  async evh_5477420070495986_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5477420070495986_reload.executeFromDOM(this, event, scope);
  }

  async evh_6337614691287098_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6337614691287098_reload.executeFromDOM(this, event, scope);
  }

  async evh_2406129194387753_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2406129194387753_reload.executeFromDOM(this, event, scope);
  }

  async evh_1840158740026147_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1840158740026147_reload.executeFromDOM(this, event, scope);
  }

  async evh_4071170783051919_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4071170783051919_reload.executeFromDOM(this, event, scope);
  }

  async evh_7713630524832656_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7713630524832656_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2656: actions.CloseModalAction;
    evh_7315092382398562_close_2655: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_2658: actions.CloseModalAction;
    evh_2248226175642056_close_2657: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_2660: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_2659: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_6705964765214521_closeComponent_2662: actions.CloseComponentAction;
    evh_6705964765214521_success_2661: actions.EventHandlerImpl;
    evh_6705964765214521_success: actions.EventHandlerGroup;
    act_6806515264385235_reloadComponentData_2664: actions.ReloadComponentDataAction;
    evh_6806515264385235_success_2663: actions.EventHandlerImpl;
    evh_6806515264385235_success: actions.EventHandlerGroup;
    act_5477420070495986_reloadComponentData_2666: actions.ReloadComponentDataAction;
    evh_5477420070495986_reload_2665: actions.EventHandlerImpl;
    evh_5477420070495986_reload: actions.EventHandlerGroup;
    act_6337614691287098_reloadComponentData_2668: actions.ReloadComponentDataAction;
    evh_6337614691287098_reload_2667: actions.EventHandlerImpl;
    evh_6337614691287098_reload: actions.EventHandlerGroup;
    act_2406129194387753_reloadComponentData_2670: actions.ReloadComponentDataAction;
    evh_2406129194387753_reload_2669: actions.EventHandlerImpl;
    evh_2406129194387753_reload: actions.EventHandlerGroup;
    act_1840158740026147_reloadComponentData_2672: actions.ReloadComponentDataAction;
    evh_1840158740026147_reload_2671: actions.EventHandlerImpl;
    evh_1840158740026147_reload: actions.EventHandlerGroup;
    act_4071170783051919_reloadComponentData_2674: actions.ReloadComponentDataAction;
    evh_4071170783051919_reload_2673: actions.EventHandlerImpl;
    evh_4071170783051919_reload: actions.EventHandlerGroup;
    act_7713630524832656_reloadComponentData_2676: actions.ReloadComponentDataAction;
    evh_7713630524832656_reload_2675: actions.EventHandlerImpl;
    evh_7713630524832656_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2656 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2656_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2655 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2656,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2655],
      }
    );
    const act_2248226175642056_closeModal_2658 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2657 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_2658,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2657],
      }
    );
    const act_8320016629450276_reloadComponentData_2660 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_2659 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_2660,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_2659],
      }
    );
    const act_6705964765214521_closeComponent_2662 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_6705964765214521_success_2661 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_closeComponent_2662,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const evh_6705964765214521_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_success_2661],
      }
    );
    const act_6806515264385235_reloadComponentData_2664 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_6806515264385235_success_2663 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_reloadComponentData_2664,
        event: "success",
        displayName: "reloadComponentData",
      }
    );
    const evh_6806515264385235_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_6806515264385235_success_2663],
      }
    );
    const act_5477420070495986_reloadComponentData_2666 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5477420070495986_reload_2665 = new actions.EventHandlerImpl(
      {
        action: act_5477420070495986_reloadComponentData_2666,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5477420070495986_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5477420070495986_reload_2665],
      }
    );
    const act_6337614691287098_reloadComponentData_2668 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_6337614691287098_reload_2667 = new actions.EventHandlerImpl(
      {
        action: act_6337614691287098_reloadComponentData_2668,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_6337614691287098_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_6337614691287098_reload_2667],
      }
    );
    const act_2406129194387753_reloadComponentData_2670 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2406129194387753_reload_2669 = new actions.EventHandlerImpl(
      {
        action: act_2406129194387753_reloadComponentData_2670,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_2406129194387753_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_2406129194387753_reload_2669],
      }
    );
    const act_1840158740026147_reloadComponentData_2672 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1840158740026147_reload_2671 = new actions.EventHandlerImpl(
      {
        action: act_1840158740026147_reloadComponentData_2672,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_1840158740026147_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1840158740026147_reload_2671],
      }
    );
    const act_4071170783051919_reloadComponentData_2674 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_4071170783051919_reload_2673 = new actions.EventHandlerImpl(
      {
        action: act_4071170783051919_reloadComponentData_2674,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_4071170783051919_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_4071170783051919_reload_2673],
      }
    );
    const act_7713630524832656_reloadComponentData_2676 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7713630524832656_reload_2675 = new actions.EventHandlerImpl(
      {
        action: act_7713630524832656_reloadComponentData_2676,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7713630524832656_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7713630524832656_reload_2675],
      }
    );
    return {
      act_7315092382398562_closeModal_2656,
      evh_7315092382398562_close_2655,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_2658,
      evh_2248226175642056_close_2657,
      evh_2248226175642056_close,
      act_8320016629450276_reloadComponentData_2660,
      evh_8320016629450276_clickPreventStop_2659,
      evh_8320016629450276_clickPreventStop,
      act_6705964765214521_closeComponent_2662,
      evh_6705964765214521_success_2661,
      evh_6705964765214521_success,
      act_6806515264385235_reloadComponentData_2664,
      evh_6806515264385235_success_2663,
      evh_6806515264385235_success,
      act_5477420070495986_reloadComponentData_2666,
      evh_5477420070495986_reload_2665,
      evh_5477420070495986_reload,
      act_6337614691287098_reloadComponentData_2668,
      evh_6337614691287098_reload_2667,
      evh_6337614691287098_reload,
      act_2406129194387753_reloadComponentData_2670,
      evh_2406129194387753_reload_2669,
      evh_2406129194387753_reload,
      act_1840158740026147_reloadComponentData_2672,
      evh_1840158740026147_reload_2671,
      evh_1840158740026147_reload,
      act_4071170783051919_reloadComponentData_2674,
      evh_4071170783051919_reload_2673,
      evh_4071170783051919_reload,
      act_7713630524832656_reloadComponentData_2676,
      evh_7713630524832656_reload_2675,
      evh_7713630524832656_reload,
      reload: act_8320016629450276_reloadComponentData_2660,
    }
  }
}

Vue.component("Company", Company);

</script>